// @ts-nocheck

import { Licences } from '../../../types/common';

export const BoomAllowedLicences = [Licences.FR, Licences.DE, Licences.ES];
export const BoomVersion = 1;
